import { deviceType } from 'detect-it';
import { useIsTouchDevice } from '@doxyme/ui-foundation/hooks';

/**
 * Returns `true` if the current device is touch-only (not hybrid),
 * or `false` for hybrid and non-touch devices.
 *
 * @remarks
 * - `useIsTouchDevice` is used to correctly detect touch in browser emulators and various touch devices.
 * - `deviceType` helps filter out hybrid devices.
 * Since emulators report `mouseOnly` via `deviceType`, both checks are required for accuracy.
 */
export const useIsTouchNonHybrid = () => {
  const isTouchDevice = useIsTouchDevice();
  const isHybridDevice = deviceType === 'hybrid';

  return isTouchDevice && !isHybridDevice;
};
